import * as actions from '@/constants/actions';
import * as mutations from '@/constants/mutations';

export default {
    state: {
        // toast component visibility
        show: false,
        // text to display
        text: '',
    },
    mutations: {
        /**
         * change toast visibility
         * @param {Object}  state       vuex state
         * @param {Boolean} [show=true] true to show toast
         */
        [mutations.SHOW_TOAST](state, show = true) {
            state.show = show;
        },
        /**
         * change toast display text
         * @param {Object}  state       vuex state
         * @param {Boolean} [show=true] true to show toast
         */
        [mutations.SET_TOAST_TEXT](state, text) {
            state.text = text;
        },
    },
    actions: {
        /**
         * change toast visibility
         */
        [actions.SHOW_TOAST]({ commit }, show) {
            commit(mutations.SHOW_TOAST, show);
        },
        /**
         * change toast display text
         */
        [actions.SET_TOAST_TEXT]({ commit }, text) {
            commit(mutations.SET_TOAST_TEXT, text);
        },
        /**
         * set text and show a toast
         */
        [actions.TRIGGER_TOAST]({ commit }, text) {
            commit(mutations.SET_TOAST_TEXT, text);
            commit(mutations.SHOW_TOAST, true);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/ToastModule.js